import httpStatus from 'http-status';
import { FilterQuery } from 'mongoose';

import Tag from '@/modules/master/constructionStatus/tags/tag.model';
import ApiError from '@/shared/utils/errors/ApiError';
import { IConstructionFilter, ITag } from '@/modules/master/constructionStatus/constructionStatus.interfaces';
import { PaginateOptions } from '@/shared/utils/plugins/paginate/paginate';
import responseCodes from '@/shared/utils/responseCode/responseCode';
import { defaultStatus } from '@/shared/utils/responseCode/httpStatusAlias';
import { safeDeleteById } from '@/shared/utils/guard/ref-guard';

const { TagResponseCodes } = responseCodes;

export const create = async (body: ITag): Promise<ITag> => {
  const { name } = body;

  const existing = await Tag.findOne({
    name: name,
  });

  if (existing)
    throw new ApiError(
      defaultStatus.BAD_REQUEST,
      'Tag with this name already exists.',
      true,
      '',
      TagResponseCodes.TAG_ALREADY_EXISTS,
    );

  return await Tag.create(body);
};

export const getById = async (id: string): Promise<ITag> => {
  const tag = await Tag.findById(id);
  if (!tag) throw new ApiError(httpStatus.NOT_FOUND, 'Tag not found');
  return tag;
};

export const update = async (
  id: string,
  body: Partial<ITag>,
): Promise<ITag> => {
  const { name } = body;

  if (name) {
    const existing = await Tag.findOne({ name });

    if (existing && existing._id.toString() !== id) 
      throw new ApiError(
        defaultStatus.BAD_REQUEST,
        'Tag with this name already exists.',
        true,
        '',
        TagResponseCodes.TAG_ALREADY_EXISTS,
      );
  }

  const tag = await Tag.findByIdAndUpdate(id, body, {
    new: true,
    runValidators: true,
  });

  if (!tag) throw new ApiError(httpStatus.NOT_FOUND, 'Tag not found');
  return tag;
};


export const remove = async (id: string): Promise<boolean> => {
 await safeDeleteById(Tag, id, TagResponseCodes.TAG_IN_USE);
  return true;
};

export const list = (query: Record<string, unknown>): Promise<ITag[]> => Tag.find(query);

export const queryTags = async (
  filter: IConstructionFilter = {},
  options: PaginateOptions = {},
) => {
  const { search, ...restFilter } = filter;

  const queryFilter: FilterQuery<ITag> = {
    ...restFilter,
  };

  if (search) 
    queryFilter.$or = [{ name: { $regex: search, $options: 'i' } }];
  

  return await Tag.paginate(queryFilter, options);
};
